import { CSSProperties } from 'react';

export const setBgImageStyle = (
  url?: string | null
): CSSProperties | undefined =>
  url && url.length
    ? {
        backgroundImage: `url(${url})`
      }
    : {};
